module.exports = __webpack_public_path__ + "static/img/3-info-b4.ec4a3c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b4.jpg
// module id = h8ir
// module chunks = 0